import React from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../App.css";

export interface IMessageBoxParams {
  /**
   * タイトル
   */
  title: string;
  /**
   * メッセージ
   */
  message: string;
  /**
   * Closeボタンを押した場合のCalllback
   */
  onClose?: () => void;
}

export interface IMessageBoxProps extends IMessageBoxParams {
  /**
   * メッセージボックスを表示する場合はtrue
   */
  show: boolean;
}

/**
 * メッセージボックス
 */
export default function MessageBox(props: IMessageBoxProps) {
  const { t } = useTranslation();
  return (
    <Modal show={props.show} onHide={props.onClose} animation={false}>
      <Modal.Header closeButton>
        <div>{props.title}</div>
      </Modal.Header>
      <Modal.Body>
        <div>{props.message}</div>
        <div className="dialog-buttons">
          <Button className="dialog-button" onClick={props.onClose}>
            {t("messagebox_close")}
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
